import { z } from 'zod/v4';

/**
 * `POST /api/ai-extraction-feedback`: a user's verdict on an AI extraction
 * they reviewed (the audit-AI dialogs' thumbs up or down), keyed on the
 * reviewed entity rather than on a file, so CAP-only imports can be rated too.
 */
export const AiExtractionFeedbackDataSchema = z.object({
  result: z.string().min(1, 'Result is required'),
  message: z.string().optional(),
  entityType: z.string().min(1, 'Entity type is required'),
  entityId: z.string().min(1, 'Entity ID is required'),
});

export const AiExtractionFeedbackResponseSchema = z.object({
  message: z.string(),
  feedbackId: z.string(),
  entityType: z.string(),
  entityId: z.string(),
});

export type IAiExtractionFeedbackData = z.infer<
  typeof AiExtractionFeedbackDataSchema
>;
export type IAiExtractionFeedbackResponse = z.infer<
  typeof AiExtractionFeedbackResponseSchema
>;
